import Link from '../../components-library/navigation/Link';

export default function Impressum(): JSX.Element {
  return (
    <div className="lg:p-lg p-md">
      <h1>Impressum</h1>
      <p className="mt-md">Betreiber der Website von foodamigos.io ist die</p>
      <div className="mt-md">
        <p>Foodamigos GmbH</p>
        <p>Am Hauptbahnhof 6</p>
        <p>53111 Bonn</p>
      </div>
      <p className="mt-md">Tel.: 015203602293</p>
      <p className="mt-md">info@foodamigos.io</p>
      <p className="mt-md">Registergericht: Amtsgericht Bonn</p>
      <p className="mt-md">Handelsregisternummer HRB 26506</p>
      <p className="mt-md">USt.-IdNr. DE347702854</p>
      <p className="mt-md">Geschäftsführer: Artur Zvinchuk</p>
      <p className="mt-md">Rechtliche Hinweise</p>
      <p className="mt-md">Verbraucherinformationen gemäß Verordnung (EU) Nr. 524/2013:</p>
      <p className="mt-md">
        Im Rahmen der Verordnung über Online-Streitbeilegung in Verbraucherangelegenheiten steht unter{' '}
        <Link to="http://ec.europa.eu/consumers/odr" /> eine Online-Streitbeilegungsplattform der EU-Kommission zur
        Verfügung.
      </p>
    </div>
  );
}
